<script>
  export let logo;
</script>

<style></style>

<a href="/">
  <div class="flex flex-col space-y-1 items-center">
    <div class="w-12 opacity-80">
      <img src={logo.src} alt={logo.alt} class="object-cover" />
    </div>
    <h1 class="text-xs uppercase tracking-widest font-black text-white text-opacity-70">R-ECO</h1>
  </div>
</a>